"use client";
import { IBlocks } from "@/types";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import React from "react";
import { toast } from "sonner";
import CardSetting from "@/components/admin/settings/CardSetting";
interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}
function isValidYoutubeChannelId(id: string) {
    return /^UC[A-Za-z0-9_-]*$/.test(id);
}
export default function YoutubeVideoLatestOptions({
    block,
    blockUpdate,
    update,
}: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    const [name, setName] = React.useState(block.name);
    const [url, setUrl] = React.useState(block.url);
    return (
        <div className="flex w-full flex-col gap-3">
            <div className="flex w-full flex-col gap-3">
                <CardSetting title="General" noBorder>
                    <div className="flex w-full flex-col gap-3">
                        <Input
                            label="Block Title"
                            variant="card"
                            className="w-full"
                            required
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value);
                                blockUpdate({
                                    ...block,
                                    name: e.target.value,
                                });
                            }}
                            onBlur={(e) => {
                                if (oldBlock.name != e.target.value) {
                                    update({
                                        ...block,
                                        name: e.target.value,
                                    });
                                    setOldBlock({
                                        ...oldBlock,
                                        name: e.target.value,
                                    });
                                }
                            }}
                        />
                        <Input
                            label="YouTube Channel ID"
                            variant="card"
                            className="w-full"
                            type="text"
                            value={url}
                            onChange={(e) => {
                                setUrl(e.target.value);
                                blockUpdate({
                                    ...block,
                                    url: e.target.value,
                                });
                            }}
                            onBlur={(e) => {
                                if (!isValidYoutubeChannelId(e.target.value)) {
                                    return toast.error(
                                        `The Channel ID needs to be a valid YouTube Channel ID, such as "UCkLsrZLQiajUbBPYi3kok_w"`
                                    );
                                }
                                if (oldBlock.url != e.target.value) {
                                    update({
                                        ...block,
                                        url: e.target.value,
                                    });
                                    setOldBlock({
                                        ...oldBlock,
                                        url: e.target.value,
                                    });
                                }
                            }}
                        />
                        <Label variant="subtoggle">
                            Your channel ID can be found{" "}
                            <a
                                className="underline"
                                target="_blank"
                                href="https://www.youtube.com/account_advanced"
                            >
                                here
                            </a>
                        </Label>
                        <div className="flex items-center justify-between gap-4">
                            <Label>Show Custom Title?</Label>
                            <Switch
                                checked={block.options?.show_custom_title}
                                onCheckedChange={(value) => {
                                    blockUpdate({
                                        ...block,
                                        options: {
                                            ...block.options,
                                            show_custom_title: value,
                                        },
                                    });
                                    update({
                                        ...block,
                                        options: {
                                            ...block.options,
                                            show_custom_title: value,
                                        },
                                    });
                                }}
                            />
                        </div>
                        <div className="flex items-center justify-between gap-4">
                            <Label>Hide Title?</Label>
                            <Switch
                                checked={block.options.hide_title}
                                onCheckedChange={(value) => {
                                    blockUpdate({
                                        ...block,
                                        options: {
                                            ...block.options,
                                            hide_title: value,
                                        },
                                    });
                                    update({
                                        ...block,
                                        options: {
                                            ...block.options,
                                            hide_title: value,
                                        },
                                    });
                                }}
                            />
                        </div>
                    </div>
                </CardSetting>
            </div>
        </div>
    );
}
